module.exports = __webpack_public_path__ + "img/left-unpayment-image.d7b69b3c.svg";